.animations {
  animation: field-appear 0.4s ease;
}

@keyframes field-appear {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvYnVpbGR1c2VyL3dvcmsvMTI1ODI5YTU5MGEwYjMxYS9wYWNrYWdlcy9mb3JtLWZpZWxkcy9kaXN0L2VzbS9hbmltYXRpb25zIiwic291cmNlcyI6WyJncmlkLWFuaW1hdGlvbnMubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTs7O0FBR0Y7RUFDRTtJQUNFO0lBQ0E7O0VBRUY7SUFDRTtJQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLmFuaW1hdGlvbnMge1xuICBhbmltYXRpb246IGZpZWxkLWFwcGVhciAwLjRzIGVhc2U7XG59XG5cbkBrZXlmcmFtZXMgZmllbGQtYXBwZWFyIHtcbiAgMCUge1xuICAgIG9wYWNpdHk6IDA7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC0xMHB4KTtcbiAgfVxuICAxMDAlIHtcbiAgICBvcGFjaXR5OiAxO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgwKTtcbiAgfVxufVxuIl19 */